import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { applyPageMeta, PAGE_SEO_CONFIG } from "../lib/seoMeta";

export default function Forbidden() {
  useEffect(() => {
    applyPageMeta(PAGE_SEO_CONFIG.forbidden);
  }, []);

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-4 py-16 bg-white text-neutral-900">
      <div className="relative mb-6">
        <div className="text-9xl font-extrabold text-neutral-100 select-none">403</div>
        <div className="absolute inset-0 flex items-center justify-center">
          <i className="fa-solid fa-lock text-5xl text-yellow-500 animate-pulse" />
        </div>
      </div>
      <h1 className="text-3xl font-extrabold tracking-tight text-neutral-900 sm:text-4xl mb-4">
        Adgang nægtet
      </h1>
      <p className="text-neutral-600 max-w-md mb-8 leading-relaxed">
        Du har ikke tilladelse til at se denne side. Hvis du mener, at dette er en fejl, bedes du kontakte administratoren.
      </p>
      <div className="flex flex-wrap justify-center gap-4">
        <Link
          to="/"
          className="bg-yellow-500 hover:bg-yellow-600 text-neutral-950 font-bold px-6 py-3 rounded-xl shadow-md transition-all duration-200 cursor-pointer"
        >
          Gå til forsiden
        </Link>
        <Link
          to="/kontakt"
          className="bg-neutral-100 hover:bg-neutral-200 text-neutral-700 font-bold px-6 py-3 rounded-xl transition-all duration-200"
        >
          Kontakt os
        </Link>
      </div>
    </div>
  );
}
